import React from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { Toaster, toast } from "react-hot-toast";

const root = createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <App />
    <Toaster position="bottom-center" />
  </React.StrictMode>
);

// Single service worker registration (with update toast)
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    toast((t) => (
      <span>
        🔄 A new version is available.
        <button
          onClick={() => {
            registration.waiting?.postMessage({ type: "SKIP_WAITING" });
            toast.dismiss(t.id);
            window.location.reload();
          }}
          className="ml-2 px-3 py-1 bg-blue-600 text-white rounded text-sm"
        >
          Refresh to Update
        </button>
      </span>
    ), { duration: Infinity });
  },
});

reportWebVitals();
